import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { SUBTASK_DUE_DATE_CATEGORIES } from '../helpers/subtasks.constants';

export default function SubtaskPanelHeader({ title, count }) {
  const countClassName = useMemo(() => {
    switch (title) {
      case SUBTASK_DUE_DATE_CATEGORIES.TODAY:
        return 'subtask-panel-header-count-today';
      case SUBTASK_DUE_DATE_CATEGORIES.OVERDUE:
        return 'subtask-panel-header-count-overdue';
      case SUBTASK_DUE_DATE_CATEGORIES.NEXT:
        return 'subtask-panel-header-count-next';
      case SUBTASK_DUE_DATE_CATEGORIES.UNSCHEDULED:
        return 'subtask-panel-header-count-unscheduled';
      default:
        return '';
    }
  }, [title]);

  return (
    <div className="subtask-panel-header-container">
      <div className="subtask-panel-header">
        {title}
      </div>
      <div className={countClassName}>
        {count}
      </div>
    </div>
  );
}

SubtaskPanelHeader.propTypes = {
  title: PropTypes.string,
  count: PropTypes.number,
};

SubtaskPanelHeader.defaultProps = {
  title: '',
  count: 0,
};
